require('babel-polyfill');

require('common/styles/markdown.scss');

/**
 * Components related to Availability Showcase
 */

import componentLoader from 'utils/component_loader';
import PageColors from 'page_colors';

window.pageColors = new PageColors(window.pageColorData);

componentLoader({
  HistoryIndex: require('components/status/history_index'),
  UptimeCalendar: require('components/status/uptime_calendar'),
});




// WEBPACK FOOTER //
// ./app/javascript/packs/status.js